export default "__VITE_ASSET__zAZAlSwBPE1QdhGrRLbViQ__"